import { render, staticRenderFns } from "./StudentCol.vue?vue&type=template&id=7ca4c2cb&"
import script from "./StudentCol.vue?vue&type=script&lang=ts&"
export * from "./StudentCol.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports